export const buttonModuleIcon = {
    backgroundColor: "var(--blue-medium-color)",
    borderRadius: "50%",
    width: "74px",
    height: "74px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px"
}

export const headerModuleIcon: React.CSSProperties = {
    backgroundColor: "var(--blue-medium-color)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px"
}

export const headerModule: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: "14px"
}
